import React from 'react'

const Loader = () => (
  <div className='loader'>
    <div className="loader-container">
      <div className="loader-content">
        Loading...
      </div>
    </div>
  </div>
)

export default Loader
